/**
 * Helpers for lead basic items (item list), separate from priced quote line items.
 */

export const formatLeadItemsList = (items) => {
  if (!Array.isArray(items)) {
    return typeof items === "string" ? items : "";
  }

  return items
    .map((item) => {
      if (typeof item === "string") {
        return item.trim();
      }

      const content = item?.content || item?.description || "";
      if (!content.trim()) {
        return "";
      }

      const quantity =
        item.quantity !== undefined && item.quantity !== null
          ? Number(item.quantity)
          : 1;

      return quantity > 1 ? `${quantity} ${content}` : content;
    })
    .filter(Boolean)
    .join(", ");
};

export const normalizeLeadItemsForForm = (items) => {
  if (!Array.isArray(items)) {
    return [];
  }

  return items
    .map((item) => {
      if (typeof item === "string") {
        const trimmed = item.trim();
        return trimmed
          ? { type: "text", description: trimmed, quantity: 1 }
          : null;
      }

      const description = (item?.content || item?.description || "").trim();
      if (!description) {
        return null;
      }

      const quantity =
        item.quantity !== undefined && item.quantity !== null
          ? Number(item.quantity) || 1
          : 1;

      return {
        type: item.type || "text",
        description,
        quantity,
      };
    })
    .filter(Boolean);
};

/**
 * Resolve basic items list string from quote payload (leadItems preferred).
 */
export const resolveBasicItemsListString = (quoteData) => {
  if (quoteData?.leadItems?.length > 0) {
    return formatLeadItemsList(quoteData.leadItems);
  }

  if (quoteData?.itemSetId) {
    return "";
  }

  if (Array.isArray(quoteData?.items) && quoteData.items.length > 0) {
    return formatLeadItemsList(quoteData.items);
  }

  return "";
};

/**
 * Resolve basic items array for structured edit forms.
 */
export const resolveBasicItemsFormArray = (quoteData) => {
  if (quoteData?.leadItems?.length > 0) {
    return normalizeLeadItemsForForm(quoteData.leadItems);
  }

  if (quoteData?.itemSetId) {
    return [];
  }

  if (Array.isArray(quoteData?.items) && quoteData.items.length > 0) {
    return normalizeLeadItemsForForm(quoteData.items);
  }

  return [];
};
